"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function recursiveSearch(value, valueKey, options) {
  var selectedOption = (0, _lodash.reduce)(options, function (acc, option) {
    var result;
    if ((0, _lodash.has)(option, 'children') && !(0, _lodash.isEmpty)(option.children)) {
      result = recursiveSearch(value, valueKey, option.children);
    }
    if (result === undefined && (0, _lodash.get)(option, valueKey, null) === value.value) {
      result = option;
    }
    return result === undefined ? acc : result;
  }, undefined);
  return selectedOption;
}
function getSelectValue(value) {
  var valueKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var forceObjectValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!value) {
    return '';
  }
  if (valueKey === 'value' && !forceObjectValue) {
    if ((0, _lodash.isArray)(value)) {
      return (0, _lodash.map)(value, 'value');
    }
    return value.value;
  }
  if ((0, _lodash.isArray)(value)) {
    return (0, _lodash.map)(value, function (val) {
      return recursiveSearch(val, valueKey, options);
    });
  }
  return recursiveSearch(value, valueKey, options);
}
var _default = exports["default"] = getSelectValue;